module.exports = __webpack_public_path__ + "img/contractors.37b581da.svg";